import type { TaskStatus, TaskPriority } from './types';

export const getTaskStatusColor = (status: TaskStatus): string => {
  switch (status) {
    case 'NEW':
      return 'bg-slate-400 text-white';
    case 'LEAD_REJECT':
      return 'bg-red-400 text-white';
    case 'LEAD_PENDING':
      return 'bg-blue-400 text-white';
    case 'PARTNER_REJECT':
      return 'bg-orange-400 text-white';
    case 'PARTNER_PENDING':
      return 'bg-indigo-400 text-white';
    case 'BILLING_PENDING':
      return 'bg-amber-400 text-white';
    case 'BILLING_REJECT':
      return 'bg-red-400 text-white';
    case 'DONE':
      return 'bg-emerald-500 text-white';
    case 'BILLED':
      return 'bg-cyan-500 text-white';
    default:
      return 'bg-gray-300';
  }
};

export const getTaskPriorityVariant = (
  priority: TaskPriority | undefined
): 'destructive' | 'secondary' | 'default' | 'outline' => {
  switch (priority) {
    case 'HIGH':
      return 'destructive';
    case 'NORMAL':
      return 'secondary';
    case 'LOW':
      return 'default';
    default:
      return 'outline';
  }
};
